/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bp_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimate a solvent's boiling point under vacuum, or its vapor pressure at a given temperature, using the Antoine equation. Pick a solvent and enter the value you know.`)
};

const es_bp_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estima el punto de ebullición de un disolvente al vacío, o su presión de vapor a una temperatura dada, usando la ecuación de Antoine. Elige un disolvente e introduce el valor que conoces.`)
};

const de_bp_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schätzen Sie den Siedepunkt eines Lösungsmittels im Vakuum oder seinen Dampfdruck bei einer bestimmten Temperatur mithilfe der Antoine-Gleichung. Wählen Sie ein Lösungsmittel und geben Sie den bekannten Wert ein.`)
};

const nl_bp_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schat het kookpunt van een oplosmiddel onder vacuüm, of de dampspanning bij een bepaalde temperatuur, met de Antoine-vergelijking. Kies een oplosmiddel en voer de bekende waarde in.`)
};

const fr_bp_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimez le point d'ébullition d'un solvant sous vide, ou sa pression de vapeur à une température donnée, à l'aide de l'équation d'Antoine. Choisissez un solvant et entrez la valeur connue.`)
};

const it_bp_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stima il punto di ebollizione di un solvente sottovuoto, o la sua tensione di vapore a una data temperatura, usando l'equazione di Antoine. Scegli un solvente e inserisci il valore che conosci.`)
};

const pt_br2_bp_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estime o ponto de ebulição de um solvente sob vácuo, ou sua pressão de vapor em uma dada temperatura, usando a equação de Antoine. Escolha um solvente e informe o valor que você conhece.`)
};

const pt_bp_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estime o ponto de ebulição de um solvente sob vácuo, ou a sua pressão de vapor a uma dada temperatura, usando a equação de Antoine. Escolha um solvente e introduza o valor que conhece.`)
};

const ja_bp_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アントワン式を用いて、減圧下での溶媒の沸点、または特定の温度での蒸気圧を推定します。溶媒を選び、わかっている値を入力してください。`)
};

const zh_bp_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用安托万方程，估算溶剂在真空下的沸点，或在给定温度下的蒸气压。选择溶剂并输入已知数值。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bp_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bp_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bp_intro", locale)
	if (locale === "en") return en_bp_intro(inputs)
	if (locale === "es") return es_bp_intro(inputs)
	if (locale === "de") return de_bp_intro(inputs)
	if (locale === "nl") return nl_bp_intro(inputs)
	if (locale === "fr") return fr_bp_intro(inputs)
	if (locale === "it") return it_bp_intro(inputs)
	if (locale === "pt-BR") return pt_br2_bp_intro(inputs)
	if (locale === "pt") return pt_bp_intro(inputs)
	if (locale === "ja") return ja_bp_intro(inputs)
	return zh_bp_intro(inputs)
};